"use strict";

exports.__esModule = true;

var ramda_1 = require("ramda");

var utils_1 = require("../utils");

var rbac_1 = require("./rbac");

var generateAppConfig = function generateAppConfig(user, userProperties) {
  if (userProperties === void 0) {
    userProperties = {};
  }

  var config = {};
  var scopes = user.scopes,
      gates = user.gates,
      roles = user.roles;

  if (utils_1.getIsRbacUser(user)) {
    return rbac_1["default"](user);
  }

  var isReportingUser = utils_1.getIsReportingUser(roles);
  var isPlaybooksUser = utils_1.getIsPlaybooksUser(roles);
  var isVideoUserOnly = utils_1.getIsVideoUserOnly(scopes);
  var isVideoAdmin = utils_1.getIsVideoAdmin(roles);
  var isCalendarUser = utils_1.getIsCalendarUser(scopes, gates);
  var isBotsV2User = utils_1.getIsBotsV2User(gates);
  var hasSavedReplies = !!gates.saved_replies;
  var isPaidPlan = !!gates.premium_drift || !!gates.premium_team || !!gates.premium_enterprise;
  var hasTeams = !!gates.premium_enterprise || !!gates.has_beta_team_view;
  var hasVideoTeamLicense = !!gates.has_team_video_license;
  var hasPremiumTeam = !!gates.premium_team;
  var isOrgAdmin = utils_1.getIsOrgAdmin(scopes);
  var hasBulkClose = isOrgAdmin && !!gates.beta_bulk_close;
  var hasRerouteConversations = isOrgAdmin && !!gates.premium_enterprise;
  var hasLimitChatsForReps = isOrgAdmin && !!gates.premium_enterprise;
  var hasSessionIntegrationSync = isOrgAdmin && utils_1.isProOrAboveOrg(gates);
  var isVideoAdminOnly = isVideoAdmin && !isOrgAdmin;
  var hasDesktopApp = userProperties.has_desktop_app !== undefined && userProperties.has_desktop_app !== 'false';
  /*** My settings ***/

  config = ramda_1.set(ramda_1.lensProp('hasAccount'), true, config);

  if (isVideoAdminOnly || isBotsV2User || isVideoUserOnly || isReportingUser || isPlaybooksUser) {
    config = ramda_1.set(ramda_1.lensProp('hasProfile'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasDriftAssistant'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasEmail'), false, config);
  } else {
    config = ramda_1.set(ramda_1.lensProp('hasProfile'), true, config);
    config = ramda_1.set(ramda_1.lensProp('hasDriftAssistant'), true, config);
    config = ramda_1.set(ramda_1.lensProp('hasEmail'), true, config);
  }

  if (isVideoAdminOnly || isVideoUserOnly || isCalendarUser || isBotsV2User || isReportingUser || isPlaybooksUser) {
    config = ramda_1.set(ramda_1.lensProp('hasNotifications'), false, config);
  } else {
    config = ramda_1.set(ramda_1.lensProp('hasNotifications'), !hasDesktopApp, config);
  }

  if (isVideoAdminOnly || isVideoUserOnly || isPlaybooksUser || isReportingUser) {
    config = ramda_1.set(ramda_1.lensProp('hasMeetings'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasMeetingsInSubnav'), false, config);
  } else {
    config = ramda_1.set(ramda_1.lensProp('hasMeetings'), !isBotsV2User, config);
    config = ramda_1.set(ramda_1.lensProp('hasMeetingsInSubnav'), !isBotsV2User, config);
  }
  /*** Organization settings ***/


  if (isVideoAdminOnly) {
    config = ramda_1.set(ramda_1.lensProp('hasBilling'), true, config);
    config = ramda_1.set(ramda_1.lensProp('hasManageTeammates'), true, config);
    config = ramda_1.set(ramda_1.lensProp('hasTeams'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasOrgMeetings'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasDataPrivacy'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasSecurity'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasCompany'), false, config);
    /*** App settings ***/

    config = ramda_1.set(ramda_1.lensProp('hasWidget'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasConvoRouting'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasConversations'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasBot'), false, config);
  } else {
    config = ramda_1.set(ramda_1.lensProp('hasBilling'), !isBotsV2User, config);
    config = ramda_1.set(ramda_1.lensProp('hasManageTeammates'), !isBotsV2User, config);
    config = ramda_1.set(ramda_1.lensProp('hasTeams'), hasTeams, config);
    config = ramda_1.set(ramda_1.lensProp('hasOrgMeetings'), !isBotsV2User && isOrgAdmin, config);
    config = ramda_1.set(ramda_1.lensProp('hasDataPrivacy'), !isBotsV2User, config);
    config = ramda_1.set(ramda_1.lensProp('hasSecurity'), !isBotsV2User, config);
    config = ramda_1.set(ramda_1.lensProp('hasCompany'), !isBotsV2User, config);
    /*** App settings ***/

    config = ramda_1.set(ramda_1.lensProp('hasWidget'), !isBotsV2User, config);
    config = ramda_1.set(ramda_1.lensProp('hasConvoRouting'), !isBotsV2User, config);
    config = ramda_1.set(ramda_1.lensProp('hasConversations'), true, config);
    config = ramda_1.set(ramda_1.lensProp('hasBot'), !isBotsV2User, config);
  }
  /*** Conversation settings ***/


  if (isBotsV2User) {
    config = ramda_1.set(ramda_1.lensProp('hasSavedReplies'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasEmailSendingDomains'), true, config);
    config = ramda_1.set(ramda_1.lensProp('hasBulkClose'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasRerouteConversations'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasLimitChatsForReps'), false, config);
    config = ramda_1.set(ramda_1.lensProp('hasSessionIntegrationSync'), false, config);
  } else {
    config = ramda_1.set(ramda_1.lensProp('hasSavedReplies'), hasSavedReplies, config);
    config = ramda_1.set(ramda_1.lensProp('hasEmailSendingDomains'), isPaidPlan, config);
    config = ramda_1.set(ramda_1.lensProp('hasBulkClose'), hasBulkClose, config);
    config = ramda_1.set(ramda_1.lensProp('hasRerouteConversations'), hasRerouteConversations, config);
    config = ramda_1.set(ramda_1.lensProp('hasLimitChatsForReps'), hasLimitChatsForReps, config);
    config = ramda_1.set(ramda_1.lensProp('hasSessionIntegrationSync'), hasSessionIntegrationSync, config);
  }

  config = ramda_1.set(ramda_1.lensProp('hasAdminSettings'), isOrgAdmin || isVideoAdmin, config);
  config = ramda_1.set(ramda_1.lensProp('hasEditUserChatAccess'), isOrgAdmin, config);
  config = ramda_1.set(ramda_1.lensProp('hasTeammateAvailabilityToggle'), isOrgAdmin, config);
  config = ramda_1.set(ramda_1.lensProp('hasHelpDocs'), false, config); // unused in the non-RBAC world

  config = ramda_1.set(ramda_1.lensProp('hasTags'), !isBotsV2User, config);
  config = ramda_1.set(ramda_1.lensProp('hasEmailPreferencesLink'), !isBotsV2User, config);
  config = ramda_1.set(ramda_1.lensProp('hasInboxes'), !isBotsV2User, config);
  config = ramda_1.set(ramda_1.lensProp('hasAdvanced'), !isBotsV2User && isOrgAdmin, config);
  /*** Integration settings ***/

  config = ramda_1.set(ramda_1.lensProp('hasIntegrations'), !isVideoUserOnly, config);
  config = ramda_1.set(ramda_1.lensProp('hasSalesforce'), isOrgAdmin && hasPremiumTeam || isVideoAdmin && hasVideoTeamLicense, config);
  config = ramda_1.set(ramda_1.lensProp('hasSalesforceRouting'), isOrgAdmin, config);
  config = ramda_1.set(ramda_1.lensProp('hasSalesforceRevenueDashboard'), isOrgAdmin, config);
  config = ramda_1.set(ramda_1.lensProp('hasSalesforceContactSync'), isOrgAdmin, config);
  config = ramda_1.set(ramda_1.lensProp('hasSalesforceUserMapping'), isOrgAdmin, config);
  config = ramda_1.set(ramda_1.lensProp('hasSalesforceAttributesMapping'), isOrgAdmin, config);
  return config;
};

exports["default"] = generateAppConfig;